var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVlWordmarkOnlyLight(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Light",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 360.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: #e0e0e0;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M402.1,243.5l1.5,1.5c-10.6,35.8-35.2,50.3-65.5,50.3-46.7,0-77.9-34.5-77.9-80s35.5-77.3,80.3-77.3,64.5,20,65.2,61.8h-101.8v.3c0,38.2,18.2,60,50.6,60s30.6-3.3,47.6-16.7h0ZM304.5,188h54.8c0-22.7-8.5-37.3-23.6-37.3s-28.2,13.6-31.2,37.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M499.4,295.3h-83.9l19.1-18.2V114.1l-17.3-16.7,63-27.6v207.3l19.1,18.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M613.3,138l20.9,17.9v.3l-33.7,70.7-33.2-70.7,19.1-18.2h-92.4l18.2,15.5,73.6,141.8h2.6l65.2-139.1v-.3l21.2-17.9h-61.5,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M808.5,243.5l1.5,1.5c-10.6,35.8-35.2,50.3-65.5,50.3-46.7,0-77.9-34.5-77.9-80s35.5-77.3,80.3-77.3,64.5,20,65.2,61.8h-101.8v.3c0,38.2,18.2,60,50.6,60s30.6-3.3,47.6-16.7h0ZM710.9,188h54.8c0-22.7-8.5-37.3-23.6-37.3s-28.2,13.6-31.2,37.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M844.2,245.6v-95.9h-30.9l76.7-54.5v42.8h60l-9.1,11.7h-50.9v81.3c0,15.5,4.5,29.1,24.8,29.1s20.6-3.3,32.1-12.4l1.5,1.5c-7.6,31.2-27.9,46.1-54.2,46.1s-50-21.8-50-49.7h0Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "V_Star"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M194.6,237.9l-23.7,54.4h-1.8L70.9,87.4l-20.9-17.6h96.1l-19.1,18.2,67.6,149.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M239.7,49.4l4.7,13.7c3.3,9.5,10.6,17.2,20,20.9l12.1,4.8-12.1,4.8c-9.4,3.7-16.7,11.3-20,20.9l-4.7,13.7-4.7-13.7c-3.3-9.5-10.6-17.2-20-20.9l-12.1-4.8,12.1-4.8c9.4-3.7,16.7-11.3,20-20.9,0,0,4.7-13.7,4.7-13.7Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVlWordmarkOnlyLight);
export default __webpack_public_path__ + "static/media/VL_WordmarkOnly_Light.e4d6ee743774a4dee60c549ada09b925.svg";
export { ForwardRef as ReactComponent };